// CSS IMPORT
import "./assets/CSS/style.css";
// import "./assets/CSS/landingPage.css";
import "./assets/CSS/responsive.css";
import "react-toastify/dist/ReactToastify.css";
import "react-loading-skeleton/dist/skeleton.css";

import { Route, Routes } from "react-router-dom";
import {
  CookiePolicy,
  FaqPage,
  LandingPage,
  MyAccount,
  MyBilling,
  Pricing,
  PrivacyPolicy,
  QrAnalytics,
  QrCreator,
  QRDesign,
  QRDetail,
  QrMainPage,
  TermOfUse,
  TermsCondition,
  WhoWeAre,
  QRCodeDetail,
  Payment,
  LOGINSCREEN,
} from "./screens";
import {
  ContactUs,
  PrivateRoute,
  ScanAndRedirectQr,
  ScrollToTop,
  UnderMaintenance,
} from "./components";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { logout } from "./redux/slice/userSlice";

//SWIPER
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

function App() {
  const stripePromise = loadStripe(
    "pk_test_51FTEPWIJaRH6RptoWVl1Wp7i3zV0GRlJfe9jShWK8qaBkHKYC4c8h3IG6NH7vIRlxCb7jjRVoqMMjbt3wIi9o0em00dwOlJmRV"
  );
  const dispatch = useDispatch();
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      dispatch(logout());
    }
  }, [dispatch]);
  // "build": "react-scripts build",
  //  x`

  return (
    <>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/*" element={<LandingPage />} />
        <Route path="/login" element={<LOGINSCREEN />} />
        {/* QR ROUTES */}

        {/*******************************  TODO ********************************/}
        <Route
          path="/my-qr-codes"
          element={<PrivateRoute element={QrMainPage} />}
        />

        <Route
          path="/qr-editor"
          element={<PrivateRoute element={QrCreator} />}
        />
        <Route
          path="/qr-editor/:type"
          element={<PrivateRoute element={QRDetail} />}
        />
        <Route
          path="/qr-editor/:type/design"
          element={<PrivateRoute element={QRDesign} />}
        />
        <Route
          path="/my-qr-analytics"
          element={<PrivateRoute element={QrAnalytics} />}
        />
        <Route
          path="/my-account"
          element={<PrivateRoute element={MyAccount} />}
        />
        <Route
          path="/my-billing"
          element={<PrivateRoute element={MyBilling} />}
        />
        <Route
          path="/my-qr-codes-details"
          element={<PrivateRoute element={QRCodeDetail} />}
        />
        <Route path="/pricing" element={<PrivateRoute element={Pricing} />} />
        <Route
          path="/payment"
          element={
            <PrivateRoute
              element={() => (
                <Elements stripe={stripePromise}>
                  <Payment />
                </Elements>
              )}
            />
          }
        />

        {/******************************* PUBLIC PAGES ********************/}
        <Route path="/qrcode/:qrCodeId" element={<ScanAndRedirectQr />} />
        {/* <Route path="/who-we-are" element={<WhoWeAre />} />
        <Route path="/terms-and-conditions" element={<TermsCondition />} />
        <Route path="/terms-of-use" element={<TermOfUse />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/cookies-policy" element={<CookiePolicy />} />
        <Route path="/contact-us" element={<ContactUs />} /> */}
        <Route path="/faq" element={<FaqPage />} />
      </Routes>
      <ScrollToTop />
    </>
  );
}

export default App;

// TODO

// header .my-account-btn;

// set NODE_OPTIONS=--max-old-space-size=1228
